import { useParams } from "react-router-dom";
import { isTaskRejectProducts } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { RejectProductsPage } from "./RejectProductsPage";

const RejectProducts = () => {
    const { marketId, taskId } = useParams();

    const { tasks } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[marketId]?.[taskId];

    if (!currentTask || !isTaskRejectProducts(currentTask)) return <NotFound />;

    return <RejectProductsPage marketId={safeMarketId} task={currentTask} />;
};

export default RejectProducts;
